<nav class="side-nav h-100 overflow-y-auto" aria-label="Primary navigation">
  @for (group of visibleGroups(); track group.label) {
    <div class="side-nav__group d-flex flex-column">
      <button
        type="button"
        class="side-nav__group-header font-size-12 d-flex align-items-center justify-content-between w-100 text-uppercase bg-transparent border-0 cursor-pointer user-select-none fw-bold"
        [attr.aria-expanded]="!isCollapsed(group.label)"
        (click)="toggleGroup(group.label)">
        <span>{{ group.label }}</span>
        <i class="bi side-nav__caret font-size-10" [class.bi-chevron-down]="!isCollapsed(group.label)" [class.bi-chevron-right]="isCollapsed(group.label)" aria-hidden="true"></i>
      </button>
      @if (!isCollapsed(group.label)) {
        <ul class="side-nav__list d-flex flex-column m-0 p-0 list-unstyled">
          @for (item of group.items; track item.route) {
            <li>
              <a class="side-nav__item d-flex align-items-center font-size-14 fw-medium text-decoration-none" [routerLink]="item.route" routerLinkActive="side-nav__item--active" [routerLinkActiveOptions]="{ exact: true }">{{ item.label }}</a>
            </li>
          }
        </ul>
      }
    </div>
  }
</nav>
